import React from 'react'

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.instagram.com/oguzz0804/" className="home__social-icon">
                <i class="uil uil-instagram-alt"></i>
            </a>
            <a href="https://github.com/oguzz0804" className="home__social-icon">
                <i class="uil uil-github"></i>
            </a>
        </div>
    )
}

export default Social